<template>
	<div class="themes">
		<transition name="introfade-delay" appear v-on:after-enter="afterBg">
			<Background class="themes__background" bgid="themes" v-if="step > 0">
				<Foreground bgid="themes"/>
			</Background>
		</transition>

		<transition>
			<SiteTitle />
		</transition>

		<transition>
			<div class="content">
				<transition name="introfade" appear>
					<ul class="categories">
						<li v-for="category in categories" :key="category.id" @click="goToCategory(category)"
								:class="['category', 'category--'+category.id]">
							<SmallStar class="smallstar" v-if="step < 2" />
							<transition name="introfade-delay" appear>
								<div class="category__title" v-if="step > 1">
									<div class="color1"></div>
									<!-- <div class="color2"></div> -->
									<span lang="iu" class="name name--iu">{{ category.name_iu }}</span>
									<span class="name name--en">{{ category.name }}</span>
								</div>
							</transition>
						</li>
						<li @click="goToCategory('saved')" class="category category--saved">
							<SmallStar class="smallstar" v-if="step < 2" />
							<transition name="introfade-delay" appear>
								<div class="category__title" v-if="step > 1">
									<div class="color1"></div>
									<!-- <div class="color2"></div> -->
									<span lang="iu" class="name name--iu">ᓱᕈᓯᕐᓄᑦ ᐃᙱᐅᓰᑦ</span>
									<span class="name name--en">Saved Songs</span>
								</div>
							</transition>
						</li>
						<li @click="goToCategory('all')" class="category category--all">
							<SmallStar class="smallstar" v-if="step < 2" />
							<transition name="introfade-delay" appear>
								<div class="category__title" v-if="step > 1">
									<div class="color1"></div>
									<!-- <div class="color2"></div> -->
									<span lang="iu" class="name name--iu">ᓱᕈᓯᕐᓄᑦ ᐃᙱᐅᓰᑦ</span>
									<span class="name name--en">All Songs</span>
								</div>
							</transition>
						</li>
						<li @click="goToCategory('surprise')" class="category category--surprise">
							<SmallStar class="smallstar" v-if="step < 2" />
							<transition name="introfade-delay" appear>
								<div class="category__title" v-if="step > 1">
									<div class="color1"></div>
									<!-- <div class="color2"></div> -->
									<span lang="iu" class="name name--iu">ᓱᕈᓯᕐᓄᑦ ᐃᙱᐅᓰᑦ</span>
									<span class="name name--en">Surprise Me</span>
								</div>
							</transition>
						</li>
					</ul>
				</transition>
			</div>
		</transition>
	</div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import Background from '@/components/Background'
import Foreground from '@/components/Foreground'
import SmallStar from '@/components/illos/SmallStar'
import SiteTitle from '@/components/SiteTitle'

export default {
	name: 'Themes',
	components: {
		SiteTitle,
		Background,
		Foreground,
		SmallStar
	},
	data () {
		return {
			specialCategories: ['all', 'saved', 'surprise'],
			step: 0
		}
	},
	methods: {
		goToCategory (category) {
			if (category === 'surprise') {
				const randomCategoryIndex = Math.floor(Math.random() * (this.categories.length - 1))
				this.$router.push('/songs/' + this.categories[randomCategoryIndex].id)
			} else if (this.specialCategories.includes(category)) {
				this.$router.push('/songs/' + category)
			} else {
				this.$router.push('/songs/' + category.id)
			}
		},
		afterBg () {
			setTimeout(() => {
				this.step = 2
			}, 2000)
		}
	},
	beforeMount () {
		this.$emit('textures', true)
	},
	mounted () {
		if (this.$route.meta.animate) {
			this.step = 1
		} else {
			this.step = 2
		}
	},
	computed: {
		...mapGetters([
			'categories'
		])
	}

}
</script>

<style scoped lang="stylus">
@import "../styles/vars.styl"

.themes
	.content
		justify-content start
		position absolute
		min-width 100%
		left 0
		top 0
		min-height 100%

		.categories
			margin 0
			padding 0
			flex-grow 1
			justify-content flex-start
			align-items center

			.category
				display flex
				flex-direction column
				position absolute
				pointer-events all
				flex 0 0 auto
				margin 0 10vw
				cursor pointer
				&--all
					top 980px
					left 1550px

				&--animal
					top 640px
					left 200px

				&--celebration
					top 850px
					left 520px

				&--funny
					top 730px
					left 1270px

				&--game
					top 670px
					left 820px

				&--hand
					top 480px
					left 560px

				&--juggling
					top 450px
					left 1490px

				&--movement
					top 850px
					left 40px

				&--saved
					top 320px
					left -110px

				&--sea
					top 1110px
					left 1070px

				&--surprise
					top 460px
					left 890px
				.smallstar
					position absolute
					left 50%
					top -50%
					transform translate(-50%, -50%)
					height 18px
					width 18px

					/deep/ .path
						fill #FF522C

				&__title
					display flex
					flex-direction column
					.color1, .color2
						transform translate(-50%, -50%) scale(0.9)
						transition transform ease-in-out 1000ms
					.color1
						position absolute
						width 238px
						height 238px
						left 175px
						left 7%
						left 50%
						top 782px
						top -210%
						top 50%
						background radial-gradient(50% 50% at 50% 50%, #FF522C 4.8%, #01C3CB 52.04%, rgba(247, 245, 240, 0) 100%)
						mix-blend-mode screen
						opacity 0.5

					.color2
						position absolute
						width 238px
						height 238px
						left 175px
						left 7%
						left 50%
						top 782px
						top -210%
						top 50%
						background radial-gradient(50% 50% at 50% 50%, #FF522C 4.8%, #01C3CB 52.04%, rgba(247, 245, 240, 0) 100%)
						mix-blend-mode darken
						opacity 0.25
					&:hover
						.color1, .color2
							transform translate(-50%, -50%) scale(1.3)

				&:nth-of-type(2n)
					.color1, .color2
						width 299px
						height 299px
						background radial-gradient(50% 50% at 50% 50%, rgba(236, 0, 62, 0.7) 4.8%, rgba(250, 255, 17, 0.7) 52.04%, rgba(247, 245, 240, 0) 100%)

					.smallstar
						/deep/ .path
							fill rgba(236, 0, 62, 1)

				&:nth-of-type(3n)
					.color1, .color2
						width: 319px;
						height: 319px;
						background: radial-gradient(50% 50% at 50% 50%, rgba(76, 0, 251, 0.7) 4.8%, rgba(255, 82, 44, 0.7) 52.04%, rgba(247, 245, 240, 0) 100%);

					.smallstar
						/deep/ .path
							fill rgba(76, 0, 251, 1)

				&:nth-of-type(4n)
					.color1, .color2
						width 253px
						height 255px
						background radial-gradient(50% 50% at 50% 50%, rgba(76, 0, 251, 0.7) 4.8%, rgba(1, 195, 203, 0.7) 52.04%, rgba(247, 245, 240, 0) 100%)

					.smallstar
						/deep/ .path
							fill rgba(76, 0, 251, 1)

				&:nth-of-type(5n)
					.color1, .color2
						width 319px
						height 262px
						background radial-gradient(50% 50% at 50% 50%, rgba(255, 82, 44, 0.7) 4.8%, rgba(76, 0, 251, 0.7) 52.04%, rgba(247, 245, 240, 0) 100%)

					.smallstar
						/deep/ .path
							fill rgba(255, 82, 44, 1)

				&:nth-of-type(6n)
					.color1, .color2
						width 390px
						height 320px
						background radial-gradient(50% 50% at 50% 50%, #01C3CB 4.8%, #38C883 52.04%, rgba(247, 245, 240, 0) 100%)

					.smallstar
						/deep/ .path
							fill #01C3CB

				&:nth-of-type(7n)
					.color1, .color2
						width 369px
						height 303px
						background radial-gradient(50% 50% at 50% 50%, #4C00FB 4.8%, #38C883 52.04%, rgba(247, 245, 240, 0) 100%)

					.smallstar
						/deep/ .path
							fill #4C00FB

				&:nth-of-type(8n)
					.color1, .color2
						width 252px
						height 272px
						background radial-gradient(50% 50% at 50% 50%, #FAFF11 4.8%, #38AEC8 52.04%, rgba(247, 245, 240, 0) 100%)

					.smallstar
						/deep/ .path
							fill #FAFF11

				&:nth-of-type(9n)
					.color1, .color2
						width 449px
						height 304px
						background radial-gradient(50% 50% at 50% 50%, rgba(76, 0, 251, 0.7) 4.8%, rgba(1, 195, 203, 0.7) 52.04%, rgba(247, 245, 240, 0) 100%)

					.smallstar
						/deep/ .path
							fill rgba(76, 0, 251, 1)

				&:nth-of-type(10n)
					.color1, .color2
						width 299px
						height 299px
						background radial-gradient(50% 50% at 50% 50%, rgba(56, 200, 131, 0.7) 4.8%, rgba(250, 255, 17, 0.7) 52.04%, rgba(247, 245, 240, 0) 100%)

					.smallstar
						/deep/ .path
							fill rgba(56, 200, 131, 1)

				&:before
					//content '•'
					position absolute
					left 50%
					top: -50%;
					font-size: 80px;
					line-height: 16px;
					transform: translateX(-50%);

				.name
					white-space nowrap
					color $color-light
					body.light &
						color $color-dark

					&--iu
						font-family: Pigiarniq;
						font-style: normal;
						font-weight: 900;
						font-size: 32px;
						line-height: 47px;
						text-align: center;
						letter-spacing: 0.03em;
						text-transform: uppercase;

					&--en
						font-family: Gilroy;
						font-style: italic;
						font-weight: 900;
						font-size: 16px;
						line-height: 20px;
						text-align: center;
						letter-spacing: 0.03em;
						text-transform lowercase
</style>
